import { render, staticRenderFns } from "./PromotersTable.component.vue?vue&type=template&id=69daddf0"
import script from "./PromotersTable.component.vue?vue&type=script&lang=ts"
export * from "./PromotersTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports